import {HttpErrorScreen, LoadScreen} from 'epic-fortnite-react';
import {getInitialCmsPageSharedValues, useCmsData, PageData} from 'epic-fortnite-shared-values';
import React from 'react';
import {withRouter} from 'react-router';
import styled from 'styled-components';

import SimpleTextWithBackground from '../../components/blocks/SimpleTextWithBackground';
import SideBySide from '../../components/bundles/SideBySide';
import MetaTags from '../../components/common/MetaTags';

import CloudStreamingHeader from './CloudStreamingHeader';

const SLUG = 'cloud-gaming';

const UTM_MAP = {
  default: '3', // default - no param
  4: '4', // youtube
  5: '5', // tiktok
  6: '6', // fbinsta
  7: '7', // other
};

const StyledCloudStreamingWrapper = styled.div`
  background-color: #fff;
  color: #000;
`;

export interface CloudStreamingPageData extends PageData {
  header: any;
  twoColumnSection: any;
  textSection: any;
  faqSection: any;
}

const CloudStreamingView = (props) => {
  const {pageData, isLoading, error} = useCmsData<CloudStreamingPageData>(SLUG);
  const {header, twoColumnSection, textSection} = pageData;
  const {
    match: {params},
  } = props;

  const utmSource = `utm_source=${UTM_MAP[params.campaign] ?? UTM_MAP.default}`;

  if (isLoading) {
    return <LoadScreen show />;
  }

  if (error) {
    return <HttpErrorScreen statusCode={error.response?.status ?? 500} />;
  }

  if (!pageData) {
    return <HttpErrorScreen statusCode={404} />;
  }

  return (
    <StyledCloudStreamingWrapper>
      <MetaTags pageModel={pageData} />
      <CloudStreamingHeader data={header} utmSource={utmSource} />
      <SideBySide {...twoColumnSection} />
      <SimpleTextWithBackground {...textSection} />
    </StyledCloudStreamingWrapper>
  );
};

CloudStreamingView.getInitialSharedValues = getInitialCmsPageSharedValues(SLUG);

export default withRouter(CloudStreamingView);
